import { render, staticRenderFns } from "./drugplandistribution.vue?vue&type=template&id=590765b2&"
import script from "./drugplandistribution.vue?vue&type=script&lang=js&"
export * from "./drugplandistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports